import { Link } from "react-router-dom";

export function LandingFooter() {
  return (
    <footer className="border-t border-brd bg-surface">
      <div className="max-w-6xl mx-auto px-5 py-8 flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="font-head font-black text-turq-900 dark:text-turq-300">سجل عطاء وأثر تعليم الشرقية</div>
        <div className="text-[11px] text-mutext text-center">
          قسم المسؤولية المجتمعية والعمل التطوعي — الإدارة العامة للتعليم بالمنطقة الشرقية · «نرصد العطاء … ونقيس الأثر»
        </div>
        <Link to="/login" data-testid="footer-login-link" className="text-xs font-bold text-coral-600 hover:text-coral-900">دخول</Link>
      </div>
    </footer>
  );
}
